import { useTextField } from '../../../lib/hooks/useTextField';
import { applyNumberMask } from '../../../lib/utils';
import { TextContentCombinedProps } from './types';

const usePresenter = (props: TextContentCombinedProps): TextContentCombinedProps => {
  const { dataType } = props;
  const preprocessFunction = dataType === 'number' ? applyNumberMask : undefined;
  const {
    handleBlur,
    handleKeyDown,
    handleTextChanged,
    textAreaRef,
    textValue,
  } = useTextField(props, preprocessFunction);

  return {
    ...props,
    textArea: {
      onBlur: handleBlur,
      onKeyDown: handleKeyDown,
      onTextChanged: handleTextChanged,
      textValue: textValue,
      resizeToContent: true,
    },
    text: { value: textValue },
    textAreaRef,
  };
};

export default usePresenter;
